export default "__VITE_ASSET__DSi2K8ZP__"